module.exports = require('./_global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/_html.js
 ** module id = 352
 ** module chunks = 0
 **/